import { DealerC } from '@unikey/unikey-commons/release/comm';
import {
  portalActions,
  inputInitializer
} from '../../internal'

const initialPortalState = {
  avatarMenuOpen: false,
  dealerSwitcherOpen: false,
  activeDealer: {} as DealerC,
  modalOpen: false,
  transitioningDealers: false,
  darkModeTheme: ''
};

export function portal(state = initialPortalState, action: any) {
  switch (action.type) {
    case portalActions.TOGGLE_AVATAR_MENU:
      return {
        ...state,
        avatarMenuOpen: !!action.open
      }
    case portalActions.TOGGLE_DEALER_SWITCHER:
      return {
        ...state, 
        dealerSwitcherOpen: !!action.open
      }
    case portalActions.SET_DARK_MODE_THEME:
      return {
        ...state,
        darkModeTheme: action.theme
      }
    case portalActions.DEALER_TRANSITION_COMPLETE:
      return {
        ...state,
        transitioningDealers: state.activeDealer?.id === action.dealerId ? false : state.transitioningDealers
      }
    case portalActions.DEALER_CONTEXT_SET:
      return {
        ...state,
        activeDealer: action.dealer,
        transitioningDealers: action.changingDealers ?? false
      }
    default:
      return state
  }
}

const initialFeedbackState = {
  modalOpen: false,
  optOutModalOpen: false,
  loading: false,
  rating: 0,
  ...inputInitializer('', ['reason']),  
}

export function feedbackModal(state = initialFeedbackState, action: any) {
  switch (action.type) {
    case portalActions.TOGGLE_FEEDBACK_MODAL:
      return {
        ...state,
        modalOpen: !state.modalOpen
      }
    case portalActions.UPDATE_FEEDBACK:
      return {
        ...state,
        rating: Number.isInteger(action.feedback?.rating) ? action.feedback.rating : state.rating,
        reason: action.feedback?.reason ? action.feedback.reason : state.reason,
        loading: action.feedback?.loading ? action.feedback.loading : state.loading
      }
    case portalActions.RESET_FEEDBACK: 
      return {
        state,
        ...initialFeedbackState
      }
    default:
      return state;
  }
}

export interface IPendingRedirectActionParams extends IPendingRedirectState {}

export interface IPendingRedirectState {
  fullUrl?: string | null,
  search?: string | null,
  pathname?: string | null,
  delay?: number | null
  priority?: 'low' | 'default' | 'high' | null,
  useHistoryReplace?: boolean,
}
const initialPendingRedirectState : IPendingRedirectState = {
  fullUrl: null,
  search: null,
  pathname: null,
  delay: null,
  priority: null, 
  useHistoryReplace: false,
};
export function pendingRedirect(state: IPendingRedirectState = initialPendingRedirectState, action: any) {
  switch (action.type) {
    case portalActions.ADD_PENDING_REDIRECT:
      return {
        ...state,
        fullUrl: action.fullUrl ?? null,
        search: action.search ?? null,
        pathname: action.pathname ?? null,
        delay: action.delay ?? null, 
        priority: action.priority ?? null,
        useHistoryReplace: action.useHistoryReplace ?? false
      }
    case portalActions.CLEAR_PENDING_REDIRECT:
      return {
        ...state,
        fullUrl: null,
        search: null,
        pathname: null,
        config: null,
        priority: null,
        useHistoryReplace: false
      }
    default:
      return state;
  }
}